import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "@environments/environment";

import { ParamsService } from "@shared/Services/params.service";

import { CreditCardType } from "@salud/FacturacionCobranza/PagoEnLinea/Types/Enums/credit-card-type.enum";

import { Dropdown } from "@RGVSI/Shared/Types/Enums/dropdown.enum";
import { DropdownOption } from "@RGVSI/Shared/Types/Interfaces/dropdown-option.interface";
import { PolicyInvoicesFilter, PolicyInvoice, InvoiceInformation } from "@RGVSI/Shared/Types/Interfaces/policy-invoice.interface";

import { PolicyTypePayment } from "../Types/Enums/policy-type-payment.enum";
import { Payment, PaymentDto, PaymentResponse } from "../Types/Interfaces/payment.interface";

const { enlineaBackendUrl } = environment;

@Injectable()
export class OnlinePaymentRepository {
  constructor(private http: HttpClient, private paramsService: ParamsService) {}

  public getInvoices(filter: PolicyInvoicesFilter): Observable<PolicyInvoice[]> {
    const params = this.paramsService.mapRequestParams({ ...filter, isForOnlinePayment: true });
    return this.http.get<PolicyInvoice[]>(`${enlineaBackendUrl}/api/insurances/Invoices`, { params }).pipe(
      map((invoices) => {
        return invoices.map((invoice) => {
          return {
            ...invoice,
            contractorInformation: {
              ...invoice.contractorInformation,
              fullName: `${invoice.contractorInformation.firstName} ${invoice.contractorInformation.lastName}`,
            },
            invoiceInformation: {
              ...invoice.invoiceInformation,
              invoiceAmountToPay: invoice.invoiceInformation.currencyBalance,
            },
            policyInformation: {
              ...invoice.policyInformation,

              policy: `${invoice.policyInformation.productCode}-${invoice.policyInformation.policyNumber}`,
            },
          };
        });
      })
    );
  }

  public getDollarExchangeRate(): Observable<number> {
    return this.http.get<number>(`${enlineaBackendUrl}/api/ExchangeRates/dollar`);
  }

  public getBanks(): Observable<DropdownOption[]> {
    return this.http.get<DropdownOption[]>(`${enlineaBackendUrl}/api/insurances/Common/Dropdown/${Dropdown.Banks}`);
  }

  public payInvoices(invoices: InvoiceInformation[], payment: Payment, currencyTypeCode: string): Observable<PaymentResponse> {
    const { cardTypeCode, ...paymentRest } = payment;
    const body: PaymentDto = {
      invoices,
      ...paymentRest,
      currencyTypeCode,
      cardTypeCode: this.getCreditCardTypeCode(cardTypeCode),
    };
    return this.http.post<PaymentResponse>(`${enlineaBackendUrl}/api/seguros/OnlinePayment`, body);
  }

  private getCreditCardTypeCode(typeCode: string): string {
    const insurancesTypes = {
      [CreditCardType.Visa]: "Visa",
      [CreditCardType.MasterCard]: "MCAR",
      [CreditCardType.Amex]: "AMEX",
    };
    return insurancesTypes[typeCode];
  }

  public getPolicyTypes(): { name: string; code: string }[] {
    return [
      { name: "Riesgos Generales", code: PolicyTypePayment["Riesgos Generales"] },
      { name: "Personas", code: PolicyTypePayment.Persona },
    ];
  }
}
